export const countryCodes = [
  { code: "+93", name: "Afghanistan" },
  { code: "+355", name: "Albania" },
  { code: "+213", name: "Algeria" },
  { code: "+376", name: "Andorra" },
  { code: "+244", name: "Angola" },
  { code: "+54", name: "Argentina" },
  { code: "+374", name: "Armenia" },
  { code: "+61", name: "Australia" },
  { code: "+43", name: "Austria" },
  { code: "+994", name: "Azerbaijan" },
  { code: "+973", name: "Bahrain" },
  { code: "+880", name: "Bangladesh" },
  { code: "+375", name: "Belarus" },
  { code: "+32", name: "Belgium" },
  { code: "+501", name: "Belize" },
  { code: "+229", name: "Benin" },
  { code: "+975", name: "Bhutan" },
  { code: "+591", name: "Bolivia" },
  { code: "+387", name: "Bosnia and Herzegovina" },
  { code: "+267", name: "Botswana" },
  { code: "+55", name: "Brazil" },
  { code: "+673", name: "Brunei" },
  { code: "+359", name: "Bulgaria" },
  { code: "+226", name: "Burkina Faso" },
  { code: "+257", name: "Burundi" },
  { code: "+855", name: "Cambodia" },
  { code: "+237", name: "Cameroon" },
  { code: "+1", name: "Canada" },
  { code: "+238", name: "Cape Verde" },
  { code: "+236", name: "Central African Republic" },
  { code: "+235", name: "Chad" },
  { code: "+56", name: "Chile" },
  { code: "+86", name: "China" },
  { code: "+57", name: "Colombia" },
  { code: "+269", name: "Comoros" },
  { code: "+242", name: "Congo" },
  { code: "+243", name: "Congo (Democratic Republic)" },
  { code: "+506", name: "Costa Rica" },
  { code: "+225", name: "Côte d'Ivoire" },
  { code: "+385", name: "Croatia" },
  { code: "+53", name: "Cuba" },
  { code: "+357", name: "Cyprus" },
  { code: "+420", name: "Czech Republic" },
  { code: "+45", name: "Denmark" },
  { code: "+253", name: "Djibouti" },
  { code: "+1", name: "Dominica" },
  { code: "+1", name: "Dominican Republic" },
  { code: "+593", name: "Ecuador" },
  { code: "+20", name: "Egypt" },
  { code: "+503", name: "El Salvador" },
  { code: "+240", name: "Equatorial Guinea" },
  { code: "+291", name: "Eritrea" },
  { code: "+372", name: "Estonia" },
  { code: "+251", name: "Ethiopia" },
  { code: "+679", name: "Fiji" },
  { code: "+358", name: "Finland" },
  { code: "+33", name: "France" },
  { code: "+241", name: "Gabon" },
  { code: "+220", name: "Gambia" },
  { code: "+995", name: "Georgia" },
  { code: "+49", name: "Germany" },
  { code: "+233", name: "Ghana" },
  { code: "+30", name: "Greece" },
  { code: "+299", name: "Greenland" },
  { code: "+1", name: "Grenada" },
  { code: "+502", name: "Guatemala" },
  { code: "+224", name: "Guinea" },
  { code: "+245", name: "Guinea-Bissau" },
  { code: "+592", name: "Guyana" },
  { code: "+509", name: "Haiti" },
  { code: "+504", name: "Honduras" },
  { code: "+852", name: "Hong Kong" },
  { code: "+36", name: "Hungary" },
  { code: "+354", name: "Iceland" },
  { code: "+91", name: "India" },
  { code: "+62", name: "Indonesia" },
  { code: "+98", name: "Iran" },
  { code: "+964", name: "Iraq" },
  { code: "+353", name: "Ireland" },
  { code: "+972", name: "Israel" },
  { code: "+39", name: "Italy" },
  { code: "+1", name: "Jamaica" },
  { code: "+81", name: "Japan" },
  { code: "+962", name: "Jordan" },
  { code: "+7", name: "Kazakhstan" },
  { code: "+254", name: "Kenya" },
  { code: "+686", name: "Kiribati" },
  { code: "+965", name: "Kuwait" },
  { code: "+996", name: "Kyrgyzstan" },
  { code: "+856", name: "Laos" },
  { code: "+371", name: "Latvia" },
  { code: "+961", name: "Lebanon" },
  { code: "+266", name: "Lesotho" },
  { code: "+231", name: "Liberia" },
  { code: "+218", name: "Libya" },
  { code: "+423", name: "Liechtenstein" },
  { code: "+370", name: "Lithuania" },
  { code: "+352", name: "Luxembourg" },
  { code: "+853", name: "Macau" },
  { code: "+389", name: "North Macedonia" },
  { code: "+261", name: "Madagascar" },
  { code: "+265", name: "Malawi" },
  { code: "+60", name: "Malaysia" },
  { code: "+960", name: "Maldives" },
  { code: "+223", name: "Mali" },
  { code: "+356", name: "Malta" },
  { code: "+692", name: "Marshall Islands" },
  { code: "+222", name: "Mauritania" },
  { code: "+230", name: "Mauritius" },
  { code: "+52", name: "Mexico" },
  { code: "+691", name: "Micronesia" },
  { code: "+373", name: "Moldova" },
  { code: "+377", name: "Monaco" },
  { code: "+976", name: "Mongolia" },
  { code: "+382", name: "Montenegro" },
  { code: "+212", name: "Morocco" },
  { code: "+258", name: "Mozambique" },
  { code: "+95", name: "Myanmar" },
  { code: "+264", name: "Namibia" },
  { code: "+674", name: "Nauru" },
  { code: "+977", name: "Nepal" },
  { code: "+31", name: "Netherlands" },
  { code: "+687", name: "New Caledonia" },
  { code: "+64", name: "New Zealand" },
  { code: "+505", name: "Nicaragua" },
  { code: "+227", name: "Niger" },
  { code: "+234", name: "Nigeria" },
  { code: "+47", name: "Norway" },
  { code: "+968", name: "Oman" },
  { code: "+92", name: "Pakistan" },
  { code: "+680", name: "Palau" },
  { code: "+970", name: "Palestine" },
  { code: "+507", name: "Panama" },
  { code: "+675", name: "Papua New Guinea" },
  { code: "+595", name: "Paraguay" },
  { code: "+51", name: "Peru" },
  { code: "+63", name: "Philippines" },
  { code: "+48", name: "Poland" },
  { code: "+351", name: "Portugal" },
  { code: "+974", name: "Qatar" },
  { code: "+242", name: "Republic of the Congo" },
  { code: "+40", name: "Romania" },
  { code: "+7", name: "Russia" },
  { code: "+250", name: "Rwanda" },
  { code: "+685", name: "Samoa" },
  { code: "+378", name: "San Marino" },
  { code: "+239", name: "São Tomé and Príncipe" },
  { code: "+966", name: "Saudi Arabia" },
  { code: "+221", name: "Senegal" },
  { code: "+381", name: "Serbia" },
  { code: "+248", name: "Seychelles" },
  { code: "+232", name: "Sierra Leone" },
  { code: "+65", name: "Singapore" },
  { code: "+421", name: "Slovakia" },
  { code: "+386", name: "Slovenia" },
  { code: "+677", name: "Solomon Islands" },
  { code: "+252", name: "Somalia" },
  { code: "+27", name: "South Africa" },
  { code: "+82", name: "South Korea" },
  { code: "+211", name: "South Sudan" },
  { code: "+34", name: "Spain" },
  { code: "+94", name: "Sri Lanka" },
  { code: "+249", name: "Sudan" },
  { code: "+597", name: "Suriname" },
  { code: "+268", name: "Eswatini" },
  { code: "+46", name: "Sweden" },
  { code: "+41", name: "Switzerland" },
  { code: "+963", name: "Syria" },
  { code: "+886", name: "Taiwan" },
  { code: "+992", name: "Tajikistan" },
  { code: "+255", name: "Tanzania" },
  { code: "+66", name: "Thailand" },
  { code: "+228", name: "Togo" },
  { code: "+676", name: "Tonga" },
  { code: "+1", name: "Trinidad and Tobago" },
  { code: "+216", name: "Tunisia" },
  { code: "+90", name: "Turkey" },
  { code: "+993", name: "Turkmenistan" },
  { code: "+688", name: "Tuvalu" },
  { code: "+256", name: "Uganda" },
  { code: "+380", name: "Ukraine" },
  { code: "+971", name: "United Arab Emirates" },
  { code: "+44", name: "United Kingdom" },
  { code: "+1", name: "United States" },
  { code: "+598", name: "Uruguay" },
  { code: "+998", name: "Uzbekistan" },
  { code: "+678", name: "Vanuatu" },
  { code: "+58", name: "Venezuela" },
  { code: "+84", name: "Vietnam" },
  { code: "+967", name: "Yemen" },
  { code: "+260", name: "Zambia" },
  { code: "+263", name: "Zimbabwe" }
];

export const COMMERCIAL_HEAD_GROUP = "IndoPortCommercialHeadGroup"
export const FINANCE_MANAGER_GROUP = "IndoPortFinanceManagerGroup"
export const FACILITY_MANAGER_GROUP = "IndoPortFacilityManagerGroup"
export const CEO_GROUP = "IndoPortCEOGroup"
export const TECHNICIAN_GROUP = "IndoPortTechnicianGroup"
export const PORTOS_CUSTOMER_GROUP = "PortOSCustomerGroup"

export const RECORDS_PER_PAGE = 10
export const RECORDS_PER_PAGE_METER_MASTER = 20

export const COMPANY_NAME = "INDOPORT"


// export const CRYPTO_SECRET_KEY = "IndoPortIndoport"
export const CRYPTO_SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY

//category wise menu grouping order

export const CATEGORY_ORDER = {
  "IndoPortCommercialHeadGroup": ["Analytics", "Commercial", "Controls", "Logs"],
  "IndoPortTechnicianGroup": ["Analytics", "Facility", "Logs"],
  "IndoPortFinanceManagerGroup": ["Analytics", "Finance", "Controls", "Logs"],
  "IndoPortFacilityManagerGroup": ["Analytics", "Facility", "Finance", "Builder", "Logs"],
  "IndoPortCEOGroup": ["Analytics", "Controls", "Commercial", "Finance", "Builder", "Facility", "Logs"],
  "PortOSCustomerGroup": ["Commercial", "Finance", "Facility"]
}

// routes congigatation
export const ACLS = {
  "IndoPortCommercialHeadGroup": [
    {
      "ROUTE": "/commercialHeadDashboard",
      "PERMISSIONS": [
        "READ"
      ],
      "IMGSRC": "./images/icons/Dashboard.svg",
      "ALT": "Dashboard",
      "CATEGORY": "Analytics"
    },
    {
      "ROUTE": "/commercialHeadContracts",
      "PERMISSIONS": [
        "MANAGE",
        "READ",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Contracts",
      "CATEGORY": "Commercial"
    },
    // {
    //   "ROUTE": "/commercialHeadFMSContracts",
    //   "PERMISSIONS": [
    //     "CREATE",
    //     "UPDATE",
    //     "READ",
    //     "DELETE"
    //   ],
    //   "IMGSRC": "./images/icons/FMS_icon.svg",
    //   "ALT": "FMS Contracts"
    // },
    {
      "ROUTE": "/commercialHeadAddFacility",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/facility.svg",
      "ALT": "Facilities",
      "CATEGORY": "Commercial"
    },
    {
      "ROUTE": "/notificationLogs",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      // "IMGSRC": "./images/icons/bellbell.svg",
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Notification Logs",
      "CATEGORY": "Logs"
    },
    {
      "ROUTE": "/customers",
      "PERMISSIONS": [
        "MANAGE",
        "READ"
      ],
      "IMGSRC": "./images/icons/users-solid.svg",
      "ALT": "Customers",
      "CATEGORY": "Controls"
    },
  ],

  "IndoPortTechnicianGroup": [
    {
      "ROUTE": "/technicianDashboard",
      "PERMISSIONS": [
        "READ"
      ],
      "IMGSRC": "./images/icons/Dashboard.svg",
      "ALT": "Technician",
      "CATEGORY": "Analytics"
    },
    {
      "ROUTE": "/electricityMeterReadings",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ"

      ],
      "IMGSRC": "./images/icons/electricityMeterDark.svg",
      "ALT": "Electricity Readings",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/waterMeterReadings",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ"
      ],
      "IMGSRC": "./images/icons/WaterDark.svg",
      "ALT": "Water Readings",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/notificationLogs",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      // "IMGSRC": "./images/icons/bellbell.svg",
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Notification Logs",
      "CATEGORY": "Logs"
    },

  ],

  "IndoPortFacilityManagerGroup": [
    {
      "ROUTE": "/facilityManagerDashboard",
      "PERMISSIONS": [
        "READ"
      ],
      "IMGSRC": "./images/icons/Dashboard.svg",
      "ALT": "Dashboard",
      "CATEGORY": "Analytics"
    },
    {
      "ROUTE": "/FacilityManagerMeterMaster",
      "PERMISSIONS": [
        "CREATE",
        "READ"
      ],
      "IMGSRC": "./images/icons/credit-card-settings-outlinemeterMaster.svg",
      "ALT": "Meter Master",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/FacilityManagerAssetsList",
      "PERMISSIONS": [
        "CREATE",
        "READ"
      ],
      "IMGSRC": "./images/icons/assetsList.svg",
      "ALT": "Assets",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/financeManagerMeterReports",
      "PERMISSIONS": [
        "READ",
        "CREATE",
        "UPDATE",
      ],
      "IMGSRC": "./images/icons/meterReports.svg",
      "ALT": "Meter Reports",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/formbuilder",
      "PERMISSIONS": [
        "READ",
        "CREATE",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/form_builder.svg",
      "ALT": "Form Builder",
      "CATEGORY": "Builder"
    },
    {
      "ROUTE": "/financeManagerCalender",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/calendar.svg",
      "ALT": "Calender",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/facilityManagerWorklog",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/Worklog.svg",
      "ALT": "Worklog",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/companiesListPage",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/companies.svg",
      "ALT": "Suppliers",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/issuesAndIncidents",
      "PERMISSIONS": [
        "MANAGE",
        "READ",
      ],
      "IMGSRC": "./images/icons/issuesandincidentsicon.svg",
      "ALT": "Issues and Incidents",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/notificationLogs",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      // "IMGSRC": "./images/icons/bellbell.svg",
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Notification Logs",
      "CATEGORY": "Logs"
    },

  ],

  "IndoPortFinanceManagerGroup": [
    {
      "ROUTE": "/financeManagerDashboard",
      "PERMISSIONS": [
        "READ"
      ],
      "IMGSRC": "./images/icons/Dashboard.svg",
      "ALT": "Dashboard",
      "CATEGORY": "Analytics"
    },
    {
      "ROUTE": "/financeManagerMeterReports",
      "PERMISSIONS": [
        "READ"
      ],
      "IMGSRC": "./images/icons/meterReports.svg",
      "ALT": "Meter Reports",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/financeManagerInvoices",
      "PERMISSIONS": [
        "READ",
        "MANAGE"
      ],
      "IMGSRC": "./images/icons/invoices.svg",
      "ALT": "Invoices",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/CreditAndDebit",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/invoices.svg",
      "ALT": "Credit/Debit Notes",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/financeManagerPayments",
      "PERMISSIONS": [
        "READ",
        "MANAGE",
      ],
      "IMGSRC": "./images/icons/payments.svg",
      "ALT": "Payments",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/notificationLogs",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      // "IMGSRC": "./images/icons/bellbell.svg",
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Notification Logs",
      "CATEGORY": "Logs"
    },
    {
      "ROUTE": "/customers",
      "PERMISSIONS": [
        "MANAGE",
        "READ"
      ],
      "IMGSRC": "./images/icons/users-solid.svg",
      "ALT": "Customers",
      "CATEGORY": "Controls"
    },
  ],

  "IndoPortCEOGroup": [
    {
      "ROUTE": "/ceoDashboard",
      "PERMISSIONS": [
        "READ"
      ],
      "IMGSRC": "./images/icons/Dashboard.svg",
      "ALT": "CEO Dashboard",
      "CATEGORY": "Analytics"
    },
    {
      "ROUTE": "/users",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/usersNew.svg",
      "ALT": "Users",
      "CATEGORY": "Controls"
    },
    {
      "ROUTE": "/services",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/adminControlsNew.svg",
      "ALT": "Services",
      "CATEGORY": "Controls"
    },
    {
      "ROUTE": "/ourCompanies",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/ourCompanies.svg",
      "ALT": "Our Companies",
      "CATEGORY": "Controls"
    },
    {
      "ROUTE": "/commercialHeadContracts",
      "PERMISSIONS": [
        "MANAGE",
        "READ",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Contracts",
      "CATEGORY": "Commercial"
    },
    {
      "ROUTE": "/commercialHeadAddFacility",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/facility.svg",
      "ALT": "Facilities",
      "CATEGORY": "Commercial"
    },
    {
      "ROUTE": "/FacilityManagerMeterMaster",
      "PERMISSIONS": [
        "CREATE",
        "READ"
      ],
      "IMGSRC": "./images/icons/credit-card-settings-outlinemeterMaster.svg",
      "ALT": "Meter Master",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/financeManagerMeterReports",
      "PERMISSIONS": [
        "READ",
        "CREATE",
        "UPDATE",
      ],
      "IMGSRC": "./images/icons/meterReports.svg",
      "ALT": "Meter Reports",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/financeManagerInvoices",
      "PERMISSIONS": [
        "READ",
        "MANAGE"
      ],
      "IMGSRC": "./images/icons/invoices.svg",
      "ALT": "Invoices",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/CreditAndDebit",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/invoices.svg",
      "ALT": "Credit/Debit Notes",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/formbuilder",
      "PERMISSIONS": [
        "READ",
        "CREATE",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/form_builder.svg",
      "ALT": "Form Builder",
      "CATEGORY": "Builder"
    },
    {
      "ROUTE": "/FacilityManagerAssetsList",
      "PERMISSIONS": [
        "CREATE",
        "READ"
      ],
      "IMGSRC": "./images/icons/assetsList.svg",
      "ALT": "Assets",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/companiesListPage",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/companies.svg",
      "ALT": "Suppliers",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/financeManagerCalender",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/calendar.svg",
      "ALT": "Calender",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/facilityManagerWorklog",
      "PERMISSIONS": [
        "CREATE",
        "READ",
        "UPDATE",
        "DELETE"
      ],
      "IMGSRC": "./images/icons/Worklog.svg",
      "ALT": "Worklog",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/emailTemplates",
      "PERMISSIONS": [
        "READ",
        "CREATE",
        "UPDATE"
      ],
      "IMGSRC": "./images/icons/Email.svg",
      "ALT": "Email Templates",
      "CATEGORY": "Controls"
    },
    {
      "ROUTE": "/gstSubmissionLogs",
      "PERMISSIONS": [
        "READ",
      ],
      "IMGSRC": "./images/icons/gst.svg",
      "ALT": "GST Logs",
      "CATEGORY": "Logs"
    },
    {
      "ROUTE": "/emailLogs",
      "PERMISSIONS": [
        "READ",
      ],
      "IMGSRC": "./images/icons/Email.svg",
      "ALT": "Email Logs",
      "CATEGORY": "Logs"
    },
    {
      "ROUTE": "/licensesAndPermits",
      "PERMISSIONS": [
        "READ",
        "CREATE",
      ],
      "IMGSRC": "./images/icons/license.svg",
      "ALT": "Licenses/Permits",
      "CATEGORY": "Controls"
    },
    {
      "ROUTE": "/financeManagerPayments",
      "PERMISSIONS": [
        "READ",
        "MANAGE",
      ],
      "IMGSRC": "./images/icons/payments.svg",
      "ALT": "Payments",
      "CATEGORY": "Finance"
    },
    {
      "ROUTE": "/issuesAndIncidents",
      "PERMISSIONS": [
        "MANAGE",
        "READ",
      ],
      "IMGSRC": "./images/icons/issuesandincidentsicon.svg",
      "ALT": "Issues and Incidents",
      "CATEGORY": "Facility"
    },
    {
      "ROUTE": "/notificationLogs",
      "PERMISSIONS": [
        "CREATE",
        "UPDATE",
        "READ",
        "DELETE"
      ],
      // "IMGSRC": "./images/icons/bellbell.svg",
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Notification Logs",
      "CATEGORY": "Logs"
    },
    {
      "ROUTE": "/customers",
      "PERMISSIONS": [
        "MANAGE",
        "READ"
      ],
      "IMGSRC": "./images/icons/users-solid.svg",
      "ALT": "Customers",
      "CATEGORY": "Controls"
    },


  ],
  "PortOSCustomerGroup": [
    {
      "ROUTE": "/commercialHeadContracts",
      "PERMISSIONS": [
        "READ",
      ],
      "IMGSRC": "./images/icons/Finalcontract.svg",
      "ALT": "Contracts",
      "CATEGORY": "Commercial"
    }, {
      "ROUTE": "/financeManagerInvoices",
      "PERMISSIONS": [
        "READ",
      ],
      "IMGSRC": "./images/icons/invoices.svg",
      "ALT": "Invoices",
      "CATEGORY": "Finance"
    }, {
      "ROUTE": "/financeManagerPayments",
      "PERMISSIONS": [
        "READ",
      ],
      "IMGSRC": "./images/icons/payments.svg",
      "ALT": "Payments",
      "CATEGORY": "Finance"
    }, {
      "ROUTE": "/issuesAndIncidents",
      "PERMISSIONS": [
        "READ",
      ],
      "IMGSRC": "./images/icons/issuesandincidentsicon.svg",
      "ALT": "Issues and Incidents",
      "CATEGORY": "Facility"
    },
  ]
}


export const APP_BASE_MOD = {
  "q73ion9zv2": {
    name: "Dev",
    bgcolor: 'env-bar blue'
  },
  "n7nc6faf8g": {
    name: "QA",
    bgcolor: 'env-bar orange'
  },
  "4k04vnn7zf": {
    name: "UAT",
    bgcolor: 'env-bar purple'
  },
  "5nsqw6dttc": {
    name: "Live",
    bgcolor: 'env-bar green'
  }
};


export const dashboardColors = [
  '#63a0c9', '#ffa557', '#6cbd6c', '#b494d1',
  '#e36868', '#36A2EB', '#FFCE56', '#4BC0C0'
];